import React, { useEffect, useMemo, useState, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { X } from 'lucide-react';
import PDFViewer from './PDFViewer';
import './PdfModal.css';

const ANIMATION_MS = 250;

const PdfModal = ({ open, onClose, pdfData, currentPage, onPageChange }) => {
  const [mounted, setMounted] = useState(open);
  const [visible, setVisible] = useState(open);

  useEffect(() => {
    if (open) {
      setMounted(true);
      const raf = requestAnimationFrame(() => setVisible(true));
      return () => cancelAnimationFrame(raf);
    }

    setVisible(false);
    const t = setTimeout(() => setMounted(false), ANIMATION_MS);
    return () => clearTimeout(t);
  }, [open]);

  const handleClose = useCallback(() => {
    onClose?.();
  }, [onClose]);

  useEffect(() => {
    if (!mounted) return;

    const onKeyDown = (e) => {
      if (e.key === 'Escape') handleClose();
    };

    document.addEventListener('keydown', onKeyDown);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = prevOverflow;
    };
  }, [mounted, handleClose]);

  const modalRoot = useMemo(() => document.body, []);

  if (!mounted) return null;

  return ReactDOM.createPortal(
    <div
      className={`pdf-modal ${visible ? 'is-open' : ''}`}
      role="dialog"
      aria-modal="true"
      aria-label="PDF expandido"
      onMouseDown={handleClose}
    >
      <div
        className="pdf-modal__dialog"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="pdf-modal__topbar">
          <div className="pdf-modal__title">PDF</div>
          <button
            type="button"
            className="pdf-modal__close-btn"
            onClick={handleClose}
            title="Fechar"
          >
            <X size={18} />
            <span>Fechar</span>
          </button>
        </div>

        <div className="pdf-modal__content">
          <PDFViewer
            pdfData={pdfData}
            currentPage={currentPage}
            onPageChange={onPageChange}
          />
        </div>
      </div>
    </div>,
    modalRoot
  );
};

export default PdfModal;
